import { Controller } from '@hotwired/stimulus';

// Résultat d'un CMES proposé dès que ses points (`checks`,
// boutons radio <prefix>[<point>]) sont tous renseignés : OUI sans point NOK,
// NON sinon ; un choix fait à la main n'est plus remplacé.
export default class extends Controller {
    static values = { prefix: String, checks: Array };

    // Brouillon repris : un résultat égal à la proposition est tenu pour proposé.
    connect() {
        const proposal = this.proposal();
        if (proposal && this.value(this.name('result')) === proposal) this.proposed = proposal;
    }

    propose({ target }) {
        if (!this.checksValue.some((key) => target.name === this.name(key))) return;
        const proposal = this.proposal();
        if (!proposal) return;
        const current = this.value(this.name('result'));
        if (current && current !== this.proposed && current !== proposal) return;
        this.proposed = proposal;
        if (current === proposal) return;
        const radio = this.element.querySelector(`input[type="radio"][name="${CSS.escape(this.name('result'))}"][value="${proposal}"]`);
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // OUI sans point NOK, NON sinon ; null tant qu'un point manque.
    proposal() {
        const values = this.checksValue.map((key) => this.value(this.name(key)));
        if (values.some((value) => !value)) return null;
        return values.includes('no') ? 'no' : 'yes';
    }

    name(key) {
        return `${this.prefixValue}[${key}]`;
    }

    value(name) {
        return this.element.querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:checked`)?.value ?? '';
    }
}
